import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-exchange-info-confirm',
  templateUrl: './exchange-info-confirm.component.html',
  styleUrls: ['./exchange-info-confirm.component.scss'],
})
export class ExchangeInfoConfirmComponent implements OnInit {
  boobleModalData: any;
  loading: boolean;
  private readonly notifier: NotifierService;
  formExchange!: FormGroup;
  private destroy$ = new Subject<void>();

  constructor(
    private modalService: BoobleModalService,
    notifierService: NotifierService,
    formBuilder: FormBuilder,
    private readonly ordersService: OrdersService
  ) {
    this.notifier = notifierService;

    this.formExchange = formBuilder.group({
      SlipCode: ['', [Validators.required, Validators.pattern('.*\\S.*')]],
    });
  }

  get exchange(): any {
    return this.formExchange.value;
  }

  ngOnInit() {
    if (typeof this.boobleModalData === 'number') {
      this.loading = true;
      this.ordersService
        .getOrderById(this.boobleModalData, "false")
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (result) => {
            this.loading = false;
            this.boobleModalData = result.data;
            this.initializeComponent();
          },
          error: (err) => {
            this.loading = false;
            console.error('Erro ao carregar dados:', err);
          },
        });
    } else {
      this.initializeComponent();
    }
  }

  initializeComponent() {}

  closeModal() {
    this.modalService.dismiss(null);
  }

  exchangeConfirm() {
    this.loading = true;

    this.ordersService
      .exchangeInfo(this.boobleModalData?.id, this.exchange)
      .subscribe({
        next: () => {
          this.loading = false;
          this.closeModal();
          this.notifier.notify('success', 'Boleto confirmado com sucesso.');
          this.ordersService.updateOrderView();
        },
        error: (err) => {
          this.loading = false;
          console.error('Erro ao confirmar boleto:', err);
        },
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
